import {PageView} from "./PageView.js";
import {SignUpViewChanger} from "../util/view-changer/index.js";
import {CompanyInfoLayout} from "../components/layout/CompanyInfoLayout.js";
import {collectGtm, getUser, isWebView} from "../store.js";
import {ERROR_CODE} from "../constant.js";
import {LoadingPopup} from "../components/popup/LoadingPopup.js";
import {Header} from "../components/Header.js";

export class CompanyInfoView extends PageView {
    renderLayout() {
        const {mainText = '', subText = '' , companyName = '', employeeList = []} = this.$props;
        this.$props.CompanyInfoLayOut = new CompanyInfoLayout(this.$target, {
            isAppend: true,
            sectionId: this.getSectionId(),
            mainText,
            subText,
            companyName,
            employeeList,
            nextButton:{
                id : "joinCompanyBtn",
                text: this.getNextButtonText(),
                nextPageFunc: this.joinCompany.bind(this)
            }
        });
    }

    renderComponents() {
        if(!this.$props.CompanyInfoLayOut) {
            return;
        }

        new Header(this.$props.CompanyInfoLayOut.getHeaderLayer(), {
            isShowLoginBtn : false,
            isShowPrevBtn : true
        });

    }

    async joinCompany() {
        const data = await getUser().joinCompanyBySubDom();
        const errCode = Mutil.n2v(data?.ERR_CD)
        if (errCode === ERROR_CODE.VERIFICATION_FORGED) {
            Mutil.mlog("인증번호 검증결과가 변조되었을 수 있습니다.")

            Mutil.toast('error', data?.ERR_MSG ?? 'error.requestForged')
            setTimeout(() => {
                location.reload()
            }, 2000)
            return
        }

        const isBlockDomain = Mutil.n2v(data.ERR_CD) === ERROR_CODE.BLOCK_DOMAIN;
        if(isBlockDomain) {
            Mutil.toast("error", i18next.t(exception.error.limitEmail))
            return;
        }

        const isJoin = errCode === ERROR_CODE.SUCCESS;
        if(!isJoin) {
            Mutil.toast("error", i18next.t(common.occupy, {val: $t(dictionary.email)}))
            return;
        }

        const isManagerInvited = "Y" === Mutil.n2v(data.JNNG_ATHZ_YN , "N");
        new LoadingPopup(this.$props.CompanyInfoLayOut.getMainArticle(), {
            isAppend: true,
        });

        if(isManagerInvited) {
            if(Often.isGlobal()) {
                collectGtm("new_signup6");
            } else {
                collectGtm("new_joinup3_a");

            }
            getUser().signInWithTwoFactor(data);
            return;
        }

        SignUpViewChanger.loadCompanyJoinWaitView();
    }

    getSectionId() {
        return `profileInputSection`;
    }


    getNextButtonText () {
        return `${i18next.t(common.requestedToJoin)}`
    }

}